const input = {
  baseStyle: {},
  sizes: {
    sm: {
      field: {
        height: '10',
      },
    },
    md: {
      field: {
        height: '12',
      },
    },
  },
  variants: {
    outline: {
      field: {
        background: 'white',
        _invalid: {
          boxShadow: 'none',
        },
        _focusVisible: {
          _invalid: {
            borderColor: 'red.500',
            boxShadow: '0 0 0 1px var(--chakra-colors-red-500)',
          },
        },
      },
    },
  },
  defaultProps: {
    focusBorderColor: 'primary.500',
  },
};

export default input;
